import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import type { IFormattedTransaction } from '../../../transactions-layout/models';
import { InvoiceOptions } from '../../../print-invoice/print-invoice.component';

export class InvoiceModalData {
  constructor(public transaction: IFormattedTransaction) {}
}

@Component({
  standalone: false,
  selector: 'odin-invoice-options-modal',
  templateUrl: './invoice-options-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./invoice-options-modal.component.scss'],
})
export class InvoiceOptionsModalComponent {
  public vatRegNo: string;
  public invoiceNumber: string;
  public businessName: string;
  public businessAddress: string = '';
  public billedTo: string;
  public notes: string = '';

  constructor(
    public dialogRef: MatDialogRef<InvoiceOptionsModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: InvoiceModalData,
  ) {
    const transaction = this.data.transaction;
    const invoice = transaction.basket?.invoice;
    // cardAcceptorTaxNumber is the merchant's own tax registration number;
    // taxRegistrationNumber is the legacy name for the same value.
    this.vatRegNo = invoice?.cardAcceptorTaxNumber || invoice?.taxRegistrationNumber || '';
    this.invoiceNumber =
      invoice?.invoiceNumber || invoice?.orderNumber || transaction.crossReference || '';
    this.businessName = transaction.merchant?.name || '';
    this.billedTo = invoice?.addressee || transaction.cardHolderDetails?.name || '';
  }

  public generate(): void {
    this.dialogRef.close(
      new InvoiceOptions(
        this.vatRegNo.trim(),
        this.invoiceNumber.trim(),
        this.businessName.trim(),
        this.businessAddress.trim(),
        this.billedTo.trim(),
        this.notes.trim(),
      ),
    );
  }

  public cancel(): void {
    this.dialogRef.close(null);
  }
}
